import { css, cx } from '@linaria/core'
import { type FC, Suspense } from 'react'
import { useTranslation } from 'react-i18next'
import { Outlet, useNavigation } from 'react-router-dom'
import { Spinner } from '#components/Spinner'
import { PageHeader } from '#features/AppLayout/Header/PageHeader'
import { PageHeaderContext } from '#features/AppLayout/Header/PageHeaderContext'
import { PageLayout } from '#features/AppLayout/PageLayout'
import { style } from '#styles/index'

const mainClass = css`
  position: relative;
  display: flex;
  flex-direction: row;
  flex: 1;
  overflow: hidden;
  max-height: calc((100vh * var(--inverse-zoom)) - ${style.constants.headerHeightVariable});
  isolation: isolate;

  @media print {
    max-height: unset;
    overflow: visible;
  }

  > .loading-overlay {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
    background-color: ${style.theme.backgroundSurfacePrimary};
    opacity: 0;
    pointer-events: none;
    &.active {
      opacity: 1;
      pointer-events: all;
    }
    transition: 0.25s 0.25s ease opacity;
  }
`

export const PageRouteOutlet: FC<{ appName: string; onLogoClick: () => void }> = ({ appName, onLogoClick }) => {
  const { t } = useTranslation('shared')
  const navigation = useNavigation()
  return (
    <PageHeaderContext>
      <PageLayout>
        <PageHeader appName={appName} onLogoClick={onLogoClick} />
        <main className={cx(mainClass)}>
          <Suspense fallback={<Spinner size="xl" subtitle={t('app.loading-data', 'Loading…')} />}>
            <Outlet />
          </Suspense>
          <div className={cx('loading-overlay', navigation.state === 'loading' && 'active')}>
            <Spinner size="xl" subtitle={t('app.loading-page', 'Preparing this view')} />
          </div>
        </main>
      </PageLayout>
    </PageHeaderContext>
  )
}
